import React from 'react';
import PropTypes from 'prop-types';

import { archMap, sizeMap, widthMap } from 'constants/fitSurvey';

import Tooltip from 'components/common/Tooltip';
import styles from 'styles/components/productdetail/fitSurvey.scss';

function makeFitSurveyTooltipContent(type, ratingPercentages, ratingMap) {
  const tooltipContent = [];
  ratingMap.forEach((value, key) => {
    const ratingPercentage = ratingPercentages[key] || 0;
    const formattedRatingPercentage = Math.round(parseFloat(ratingPercentage));
    tooltipContent.push(
      <li key={`${type}Rating-${value}`} className={styles.fitSurveyRating}>
        <span className={styles.percentBar}><span style={{ width: `${ratingPercentage}%` }}/></span>
        <span className={styles.percentNumber}>{formattedRatingPercentage}%</span>
        <span className={styles.ratingText}>{value}</span>
      </li>
    );
  });
  return tooltipContent;
}

const FitSurvey = ({ reviewSummary, archFit, sizeFit, widthFit }) => {
  const { sizeRatingPercentages, widthRatingPercentages, archRatingPercentages } = reviewSummary;
  const hasFitRatings = reviewSummary.hasFitRatings === 'true';

  if (hasFitRatings) {
    const sizeFitContent = sizeFit &&
        <ul className={styles.fitSurveyTooltip}>
          {makeFitSurveyTooltipContent('size', sizeRatingPercentages, sizeMap)}
        </ul>;

    const widthFitContent = widthFit &&
        <ul className={styles.fitSurveyTooltip}>
          {makeFitSurveyTooltipContent('width', widthRatingPercentages, widthMap)}
        </ul>;

    const archFitContent = archFit &&
        <ul className={styles.fitSurveyTooltip}>
          {makeFitSurveyTooltipContent('arch', archRatingPercentages, archMap)}
        </ul>;

    return (
      <div className={styles.fitSurvey}>
        <div className={styles.fitSurveyContent}>
          <h4>Fit Survey:</h4>
          {sizeFit ? <div className={styles.fitSection}>
            <Tooltip tooltipId="sizeFit" content={sizeFitContent}>
              <strong>{sizeFit.percentage}%</strong> {sizeMap.get(sizeFit.text) || sizeFit.text}
            </Tooltip>
          </div> : null}
          {widthFit ? <div className={styles.fitSection}>
            <Tooltip tooltipId="widthFit" content={widthFitContent}>
              <strong>{widthFit.percentage}%</strong> {widthMap.get(widthFit.text) || widthFit.text}
            </Tooltip>
          </div> : null}
          {archFit ? <div className={styles.fitSection}>
            <Tooltip tooltipId="archFit" content={archFitContent}>
              <strong>{archFit.percentage}%</strong> {archMap.get(archFit.text) || archFit.text}
            </Tooltip>
          </div> : null}
        </div>
      </div>
    );
  } else {
    return null;
  }
};

FitSurvey.propTypes = {
  reviewSummary: PropTypes.object.isRequired,
  archFit: PropTypes.object,
  sizeFit: PropTypes.object,
  widthFit: PropTypes.object
};

export default FitSurvey;
